import { render, staticRenderFns } from "./TeacherGroupEditForm.vue?vue&type=template&id=4db774fa&scoped=true&"
import script from "./TeacherGroupEditForm.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db774fa",
  null
  
)

export default component.exports